<template>
  <Layout>
<PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.tickets.text')+' #'+this.$route.params.id"
      :mainPage="$t('popups.ticketresolution')"
    />


 <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @input="search(page)"
              type="search"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
       <button
              type="button"
              :disabled="ticket.status"
              @click="/*addTicketResolutions()*/preAddTicketResolutions()"
              class="btn btn-light float-end mb-4"
            >
              <span
                class="bx bxs-plus-circle float-end fa-2x"
                style="color: #2a3042 !important"
              ></span>
            </button>
      </div>
    </div>
           

            <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
              <thead>
                <tr
                  class="text-light text-center"
                  style="background-color: #2a3042 !important"
                >
                  <th scope="col">#</th>
                  <th scope="col">{{ $t("tickets.employee") }}</th>
                  <th scope="col">{{ $t("tickets.report") }}</th>
                  <th scope="col">{{ $t("tickets.finsih_time") }}</th>
                  <th scope="col">{{ $t("tickets.operations") }}</th>
                  <!-- <th scope='col'>Updated</th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(app, index) in ticket_resolutions"
                  :key="app"
                  class="text-center"
                >
                  <td>{{ index + 1 }}</td>
                  
                  <td v-if="app.emp">{{ app.emp.name }}</td>
                  <td v-html="app.report"></td>
                  <td>{{ app.created.split("T")[0] }}</td>
                  <td class="d-flex text-center justify-content-center gap-3">
                      <i class="bx bx-trash fs-4 text-danger" style="cursor: pointer;" @click="DeleteResolution(app)"></i>
                      <i class="bx bx-edit fs-4 text-secondary" style="cursor: pointer;" @click="form.report = app.report,form.emp = app.emp, form.id=app.id , openModal= true"></i>
                  </td>
                  <!-- <td>{{app.updated}}</td> -->
                </tr>
              </tbody>
            </table>


             <!--   Apps  Pagination     -->
    <div>
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(page -1): getres(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a class="page-link" href="javascript: void(0);" @click="searchModel ? search(p): getres(p)">{{
            p
          }}</a>
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(page +1): getres(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>

<div
      class="modal fade"
      id="addTicketResolutionModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
        data-bs-backdrop="static"
  data-bs-keyboard="false"
  
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("popups.addticketresolution") }}</h5>
          </div>
          <form @submit.prevent="addTicketResolution()">
          <div class="modal-body">
            <div class="row">
              
              <div class="col-12 mb-3">
                
                  <label for="" class="form-label">{{
                    $t("emp_files.emp")
                  }}</label>
                <span class="p-input-icon-right">

                  <AutoComplete
                  required
                    v-model="data.emp"
                    :suggestions="emps"
                    @complete="searchEmployees($event.query)"
                    @item-select="data.emp_id= data.emp?.id"
                    :complete-on-focus="true"
                    :optionLabel="showEmpLabel"
                    :inputClass="'form-control'"
                    class="w-100"
                  />
                   <i
                       v-if="selected"
                       class="pi pi-times"
                       @click="data.emp = null"
                       style="cursor: pointer;"
                   />
                </span>
              </div>
            
              
              <div class="col-12 mb-3">
                <label for="" class="form-label">{{
                    $t("popups.report")
                  }}</label>
              <ckeditor :editor="editor" v-model="data.report" :config="editorConfig"></ckeditor>
              </div>
           
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary">
              {{ $t("popups.add") }}
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="add_ticket_resolution_modal.hide(); "
            >
              {{$t('popups.colse')}}
            </button>
          </div>
          </form>
        </div>
      </div>
    </div>
    <BModal v-model="openModal" hide-footer :title="$t('popups.edit')">
      <BForm @submit.prevent="EditResul()">
        <div>        
        <AutoComplete
          required
            v-model="form.emp"
            :suggestions="emps"
            @complete="searchEmployees($event.query)"
            @item-select="data.emp_id= data.emp?.id"
            :complete-on-focus="true"
            :optionLabel="showEmpLabel"
            :inputClass="'form-control'"
            class="w-100"
          />
        </div>
        <div class="mt-3">
          <ckeditor :editor="editor" v-model="form.report" :config="editorConfig"></ckeditor>
          <!-- <input class="form-control" v-model="form.edit" /> -->
        </div>
        <div class="d-flex gap-4 justify-content-end mt-4">
          <button type="submit" class="btn btn-primary">{{ $t('popups.edit') }}</button>
          <button type="button" class="btn btn-secondary" @click="openModal=false">{{ $t('popups.colse') }}</button>
        </div>
      </BForm>
    </BModal>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header-v2";
import { Modal } from "bootstrap";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
export default {
  components: {
  Layout,
  PageHeader,
  ckeditor: CKEditor.component  // Add this line
},
  data() {
    return {
      del: "",
      page: 1,
      limit: 20,
      tot_pages: 0,
      pageres: 1,
      limitres: 20,
emps:[],
      searchTickets: null,
      ticket_resolutions: [],
      TicketResolutions: {},

      ticket_id: 0,
      searchModel: "",
      searchTicketResolutions: null,
      TicketResolutionsSearchMode: false,
      add_or_edit_modal: {},
      data: {},
      editor: ClassicEditor,

      editorConfig: {
        // The configuration of the editor.
      },
      editMode:false,
      ticket_modal:{},
      add_ticket_resolution_modal:{},
      ticket:{},
      form : {report: '', emp: null},
      openModal: false
      // appprices:[]
    };
  },
  methods: {
    gitresolution(searchIn) {
      this.ticket_id = searchIn.id;
      this.data = {}
this.ticket_modal.show()
      this.http.get("ticket-resolutions/" + searchIn.id).then((res) => {
        this.ticket_resolutions = res.data;
      });
    },
    getres(page){
    console.log(page)
     this.http.post('ticket-resolutions/pagination',{
      limit:this.limitres,
      page:this.page,
      ticket_id:this.$route.params.id
     }).then((res)=>{
      this.page = page
    this.tot_pages = Math.ceil(res.tot/this.limit)
    this.ticket_resolutions = res.data
       })}

    ,
    search(page){
        if(!this.searchModel.length) return this.getres(page)
    console.log(page)
     this.http.post('ticket-resolutions/search',{
      limit:this.limitres,
      page:this.page,
      ticket_id:this.$route.params.id,
      search:this.searchModel,
     }).then((res)=>{
      this.page = page
    this.tot_pages = Math.ceil(res.tot/this.limit)
    this.ticket_resolutions = res.data
       })}

    ,
    addTicketResolution() {


              this.data.ticket_id = this.$route.params.id;
              console.log("step 94 :", this.data);
              if(!this.data.emp_id){
                return this.popup.alert({
              title: "popups.error",
              msg: "popups.you_need_to_enter_emp_name",
            }); 
              }
              else{
                this.http.post("ticket-resolutions", this.data).then((res) => {
                  if(res.data){
                this.add_ticket_resolution_modal.hide()
                    this.getres(this.page)

                  }
              });
              }
              
 
 },
    preAddTicketResolutions(){

this.add_ticket_resolution_modal.show()
    },
    getTicketResolutions() {
      this.http.get("ticket-resolutions").then((res) => {
        this.ticket_resolutions = res.data;
      });
    },
      searchEmployees(search) {
      this.http
        .post(
          "emp-custodies/search-emps",
          {
            search,
            limit: 25,
            // current_emp_id: this.data.under_custody[0]?.emp_id,
          },
          null,
          true
        )
        .then((res) => {
          if (res.status) {
            this.emps = res.data;
          }
        });
    },
     showEmpLabel(one) {
      return one.name;
    },
    getTicket(){
        this.http.get('tickets/'+this.$route.params.id).then((res)=>{
            if(res.status){
                this.ticket= res.data
            }
        })
    },
    EditResul(){
      let obj = {}
      if (this.form.emp) {
        obj.emp_id = this.form.emp.id
      }
      if (this.form.report) {
        obj.report = this.form.report
      }
      console.log('result', obj)
      this.http.put('ticket-resolutions', this.form.id, obj).then(() => {
        this.edit = ''
        this.openModal = false
        this.getres(1)
        this.getTicket()
      })
    },
    DeleteResolution(app) {
      this.popup.confirm({
        title: "popups.delete",
        msg: "popups.delmessage",
      }).then((resp) => {
        if (resp) {
          this.http.delete('ticket-resolutions', app.id).then(() => {
            this.getres(1)
            this.getTicket()
          })
        }
      });

    }
  },
  mounted() {
        this.add_ticket_resolution_modal =new Modal('#addTicketResolutionModal')
this.getres(1)
this.getTicket()
  },
}
</script>

<style>

</style>